module.exports = __webpack_public_path__ + "img/1.03dd4ee3.png";